const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
document.documentElement.classList.add('js');
const hero=document.querySelector('[id$="__hero_petise"]');
const heroPhoto=hero?.querySelector('.petise-hero-photo');
if(hero&&heroPhoto){
  const heroHeadline=hero.querySelector('h1');
  if(heroHeadline)heroHeadline.textContent='Because your pet deserves better.';
  [...hero.querySelectorAll('.text-block')].forEach(block=>{
    const copy=block.textContent.trim().toLowerCase();
    if(copy.startsWith('thoughtfully chosen products')||copy.startsWith('secure checkout'))block.remove();
  });
  const heroActions=[...hero.querySelectorAll('a.button,a.button-unstyled')];
  if(heroActions[0]){
    heroActions[0].textContent='Shop Now';
    heroActions[0].href='/collections/all-products';
    heroActions[0].setAttribute('aria-label','Shop all Petise products');
  }
  heroActions.slice(1).forEach(action=>action.remove());
  const visual=document.createElement('div');
  visual.className='petise-hero-visual';
  heroPhoto.parentNode.insertBefore(visual,heroPhoto);
  const stage=document.createElement('div');
  stage.className='petise-hero-stage';
  visual.append(stage);
  stage.append(heroPhoto);
  const light=document.createElement('span');
  light.className='petise-hero-light';
  light.setAttribute('aria-hidden','true');
  visual.append(light);
  const atmosphere=document.createElement('span');
  atmosphere.className='petise-hero-atmosphere';
  atmosphere.setAttribute('aria-hidden','true');
  visual.append(atmosphere);
  if(!reduce&&matchMedia('(hover:hover) and (pointer:fine)').matches){
    let frame;
    const setDepth=(event)=>{const box=visual.getBoundingClientRect();const x=(event.clientX-box.left)/box.width-.5;const y=(event.clientY-box.top)/box.height-.5;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{visual.style.setProperty('--hero-x',x.toFixed(3));visual.style.setProperty('--hero-y',y.toFixed(3))})};
    visual.addEventListener('pointermove',setDepth,{passive:true});
    visual.addEventListener('pointerleave',()=>{visual.style.setProperty('--hero-x',0);visual.style.setProperty('--hero-y',0)},{passive:true});
  }
}
const header=document.querySelector('.header-section');
const updateHeader=()=>header?.classList.toggle('petise-header--scrolled',scrollY>24);
updateHeader();addEventListener('scroll',updateHeader,{passive:true});
const targets=document.querySelectorAll('[id$="__hero_petise"],[id$="__bs_head"]>div,[id$="__na_head"]>div,[id$="__need_head"]>div,[id$="__shop_companion"] .group-block[href],[id$="__value_props"] .group-block,[id$="__story"] .text-block');
targets.forEach((el,i)=>{el.classList.add('petise-reveal');el.dataset.delay=String(i%3)});
if(reduce||!('IntersectionObserver'in window))targets.forEach(el=>el.classList.add('is-visible'));
else{const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}}),{rootMargin:'0px 0px -8% 0px',threshold:.12});targets.forEach(el=>observer.observe(el))}
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.petise-reveal').forEach(el=>el.classList.add('is-visible')));

const petCards=[...document.querySelectorAll('[id$="__shop_companion"] .group-block:has(>.group-block__link)')];
if(petCards.length){
  const activatePetCard=card=>petCards.forEach(item=>item.classList.toggle('is-active',item===card));
  activatePetCard(petCards[0]);
  petCards.forEach(card=>{
    card.addEventListener('pointerenter',()=>activatePetCard(card),{passive:true});
    card.addEventListener('focusin',()=>activatePetCard(card));
  });
  petCards[0].parentElement?.addEventListener('pointerleave',()=>activatePetCard(petCards[0]),{passive:true});
}

function initProductShowcase(section){
  if(!section||section.classList.contains('has-petise-showcase'))return;
  const source=section.querySelector('.resource-list.hidden--mobile')||section.querySelector('.resource-list');
  const cards=[...source?.querySelectorAll('product-card')||[]].slice(0,4);
  if(cards.length<2)return;
  section.classList.add('has-petise-showcase');
  const showcase=document.createElement('div');
  showcase.className='petise-product-showcase';
  const stage=document.createElement('div');
  stage.className='petise-showcase-stage';
  const switcher=document.createElement('div');
  switcher.className='petise-showcase-switcher';
  switcher.setAttribute('role','tablist');
  switcher.setAttribute('aria-label','Choose a featured product');
  const activate=(index,focus=false)=>{
    cards.forEach((card,i)=>{const active=i===index;card.classList.toggle('is-showcase-active',active);card.setAttribute('aria-hidden',String(!active));card.inert=!active;const button=switcher.children[i];button?.setAttribute('aria-selected',String(active));button?.setAttribute('tabindex',active?'0':'-1')});
    showcase.dataset.active=String(index);if(focus)switcher.children[index]?.focus();
  };
  cards.forEach((card,index)=>{
    card.classList.add('petise-showcase-product');
    card.style.setProperty('--showcase-index',index);
    card.id=`petise-showcase-panel-${index}`;card.setAttribute('role','tabpanel');card.setAttribute('aria-labelledby',`petise-showcase-tab-${index}`);
    stage.append(card);
    const title=card.querySelector('.petise-card-title')?.textContent?.trim()||`Product ${index+1}`;
    const button=document.createElement('button');
    button.type='button';button.id=`petise-showcase-tab-${index}`;button.setAttribute('role','tab');button.setAttribute('aria-controls',card.id);button.innerHTML=`<span>0${index+1}</span><strong>${title}</strong>`;
    button.addEventListener('click',()=>activate(index));
    button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?cards.length-1:(index+(event.key==='ArrowRight'?1:-1)+cards.length)%cards.length;activate(next,true)});
    switcher.append(button);
  });
  showcase.append(stage,switcher);
  source.parentElement?.insertBefore(showcase,source);
  activate(0);
}
initProductShowcase(document.querySelector('[id$="__best_sellers"]'));
document.addEventListener('shopify:section:load',event=>initProductShowcase(event.target.matches?.('[id$="__best_sellers"]')?event.target:event.target.querySelector?.('[id$="__best_sellers"]')));

function initCollectionLayout(grid){
  if(!grid||grid.dataset.petiseToggleReady)return;
  grid.dataset.petiseToggleReady='true';
  const controls=document.createElement('div');
  controls.className='petise-layout-toggle';
  controls.setAttribute('role','group');
  controls.setAttribute('aria-label','Product layout');
  const modes=[['list','List'],['two','2 columns'],['four','4 columns']];
  const applyLayout=(mode,animate=true)=>{
    grid.dataset.petiseLayout=mode;
    sessionStorage.setItem('petise:collection-layout',mode);
    [...controls.children].forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.layout===mode)));
    if(animate&&!reduce){grid.classList.remove('is-layout-changing');void grid.offsetWidth;[...grid.children].forEach((item,index)=>item.style.setProperty('--layout-delay',`${Math.min(index,10)*28}ms`));grid.classList.add('is-layout-changing');setTimeout(()=>grid.classList.remove('is-layout-changing'),650)}
  };
  modes.forEach(([mode,label])=>{const button=document.createElement('button');button.type='button';button.dataset.layout=mode;button.innerHTML=`<span aria-hidden="true"></span>${label}`;button.addEventListener('click',()=>applyLayout(mode));controls.append(button)});
  grid.parentElement?.insertBefore(controls,grid);
  const stored=sessionStorage.getItem('petise:collection-layout');
  applyLayout(modes.some(([mode])=>mode===stored)?stored:(innerWidth<750?'two':'four'),false);
}
document.querySelectorAll('.main-collection-grid .product-grid').forEach(initCollectionLayout);
new MutationObserver(mutations=>mutations.forEach(mutation=>mutation.addedNodes.forEach(node=>{if(!(node instanceof Element))return;if(node.matches?.('.main-collection-grid .product-grid'))initCollectionLayout(node);node.querySelectorAll?.('.main-collection-grid .product-grid').forEach(initCollectionLayout)}))).observe(document.body,{childList:true,subtree:true});

const wishlistKey='petise:wishlist';
const getWishlist=()=>{try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]')}catch{return[]}};
const syncWishlist=()=>document.querySelectorAll('[data-wishlist-id]').forEach(button=>{const saved=getWishlist().includes(button.dataset.wishlistId);button.setAttribute('aria-pressed',String(saved));button.querySelector('span').textContent=saved?'♥':'♡'});
document.addEventListener('click',event=>{const button=event.target.closest('[data-wishlist-id]');if(!button)return;event.preventDefault();event.stopPropagation();const id=button.dataset.wishlistId;const items=getWishlist();const next=items.includes(id)?items.filter(item=>item!==id):[...items,id];localStorage.setItem(wishlistKey,JSON.stringify(next));syncWishlist();button.setAttribute('aria-label',next.includes(id)?'Remove from favourites':'Save to favourites')});
syncWishlist();

/* Some imported catalogs omit Shopify's variant → featured-media mapping.
   Match meaningful words in the variant title to gallery alt text first.
   Native assigned featured media always wins. */
const productMediaCache=new Map();
async function selectFallbackVariantMedia(picker,variantId){
  if(!variantId)return;
  const previousGallery=document.querySelector('.product-information media-gallery');
  const productUrl=(picker.dataset.productUrl||location.pathname).split('?')[0];
  let product=productMediaCache.get(productUrl);
  if(!product){
    try{product=await fetch(`${productUrl}.js`).then(response=>response.json());productMediaCache.set(productUrl,product)}catch{return}
  }
  const variantIndex=product.variants?.findIndex(variant=>String(variant.id)===String(variantId));
  const selectedVariant=product.variants?.[variantIndex];
  if(variantIndex<0||selectedVariant?.featured_media||selectedVariant?.featured_image)return;
  for(let attempt=0;attempt<20;attempt+=1){
    await new Promise(resolve=>setTimeout(resolve,50));
    const currentGallery=document.querySelector('.product-information media-gallery');
    if(currentGallery&&currentGallery!==previousGallery)break;
  }
  const gallery=document.querySelector('.product-information media-gallery');
  if(!gallery)return;
  const ignoredWords=new Set(['little','big','small','medium','large','xl','xxl','size']);
  const variantWords=String(selectedVariant.title||'').toLowerCase().match(/[\p{L}\p{N}]+/gu)?.filter(word=>word.length>2&&!ignoredWords.has(word))||[];
  const thumbnails=[...gallery.querySelectorAll('button img')];
  const matchedIndex=thumbnails.findIndex(image=>{
    const description=`${image.alt||''} ${image.src||''}`.toLowerCase();
    return variantWords.some(word=>description.includes(word));
  });
  if(matchedIndex<0)return;
  const thumbnailButton=thumbnails[matchedIndex]?.closest('button');
  if(thumbnailButton)thumbnailButton.click();
  else gallery.slideshow?.select(matchedIndex,undefined,{animate:true});
}
document.addEventListener('change',event=>{
  const picker=event.target.closest?.('variant-picker');
  if(!picker||event.target.closest('product-card'))return;
  const selected=event.target instanceof HTMLSelectElement?event.target.options[event.target.selectedIndex]:event.target;
  selectFallbackVariantMedia(picker,selected?.dataset?.variantId);
});
